<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <h3>{{changeUploadData.document}}</h3>
          <i
            class="el-icon-close"
            @click="dialog=false"></i>
        </div>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>{{changeUploadData.document}}</span>
            <el-form-item
              ref="pcy_pdf_path_id"
              prop="pcy_pdf_path_id">
              <v-upload
                :card="true"
                :fileData="formData[formKey]"
                :edit="true"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>{{changeUploadData.document}} Policy No.</span>
            <el-form-item
              :ref="`${extraKey}_pcy_no`"
              :prop="`${extraKey}_pcy_no`">
              <v-input v-model="formData[`${extraKey}_pcy_no`]" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="onContinue">Continue</v-button>
      </div>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {updateOrderExtraPcy} from '@/api/order'

export default {
  name: 'ExtraBenefitsDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
      },
      extraRules: {
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        extra_car_wind_pro_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed:{
    formKey(){
      let {type=''} = this.changeUploadData||{}
      return type
    },
    extraKey(){
      let {type=''} = this.changeUploadData||{}
      let key = type.split('_path')[0]
      return key
    }
  },
  watch: {
    changeUploadData:{
      immediate: true,
      handler(val) {
        if(val){
          let {file,type=''} = this.changeUploadData||{}
          let key = type.split('_path')[0]
          let params = {}
          if(type)
          {
            params[`${key}_pcy_no`] = ''
            params[type] = null
            params[`${type}_path`] = ''
            params[`${type}_id`] = ''
          }
          this.formData = params
        }
      }
    },
    dialog: {
      immediate: true,
      handler(val) {
        if(val) {
          let {file,type=''} = this.changeUploadData||{}
          let key = type.split('_path')[0]
          let {extra_content_list={}} = this.form||{}
          const {path,id} = file||{}
          this.formData[type] = file
          this.formData[`${type}_id`] = id
          this.formData[`${type}_path`] = path
          if(extra_content_list)
          {
            let {pcy_no} = extra_content_list[key]||{}
            this.formData[`${key}_pcy_no`] =pcy_no
          }
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result }) {
      let {file,type} = this.changeUploadData||{}
      let key = type.split('_path')[0]
      this.$set(this.formData, type, data)
      this.$set(this.formData, `${type}_id`, data.id)
      this.$set(this.formData,  `${type}_path`, data.path)
      this.$refs['form'].clearValidate([`${type}_path`])
    },
    handlerDeleteFile() {
      let {file,type} = this.changeUploadData||{}
      let key = type.split('_path')[0]
      this.$set(this.formData, type, null)
      this.$set(this.formData, `${type}_id`, '')
      this.$set(this.formData, `${type}_path`, '')
      this.$refs['form'].clearValidate([`${type}_id`])
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().updateOrderExtraPcy()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        updateOrderExtraPcy: async () => {
          let params = {
            order_id: this.orderId,
            ...this.formData
          }
          const { data } = await updateOrderExtraPcy(params)

          this.dialog = false
          this.$emit('success', this.formData,this.formKey)

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  //padding: 15px;
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
      h3{
        padding-bottom: 0;
      }
    }
  }
  .dialog-footer {
    //margin: 15px -15px -15px;
    padding: 15px;
    text-align: right;
    background: #F9FAFB;
  }
  .form-item {
    & > span {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .dialog-body{
    padding: 15px;
  }
}
</style>
